import { BehaviorSubject, Observable } from "rxjs";
import { OFFICE_API_VERSION } from "@core/core-boot/core-boot";
import { eHostCustom, ePlatformCustom, IClientENV, ICoreEnv } from "@core/core-env/core-env.types";
import { environment } from "@env";

export const OFFICE_API_WEB_VERSION  = 999 as const

export class CoreEnv implements ICoreEnv {
    private _environment: BehaviorSubject<IClientENV> = new BehaviorSubject<IClientENV>(this.env);

    constructor(private env: IClientENV) {}

    public get(): IClientENV {
        return this._environment.getValue();
    }

    public $get(): Observable<IClientENV> {
        return this._environment.asObservable();
    }

    get isOffice(): boolean {
        const isHasOffice = this._environment.getValue().office;
        return !!isHasOffice && isHasOffice === OFFICE_API_VERSION.v1;
    }

    public async isHostOutlook(): Promise<boolean> {
        const info = this.get()

        return info.host === Office.HostType.Outlook
    }

    static async init(): Promise<CoreEnv> {
        const info = await Office.onReady()
        if (info.platform && info.host) {
            if (environment.office_core_version === OFFICE_API_VERSION.v2) {
                const env =  {
                    ...info,
                    office: OFFICE_API_VERSION.v2
                }

                return new CoreEnv(env);
            }

            const env = {
                ...info,
                office: OFFICE_API_VERSION.v1
            }

            return new CoreEnv(env);
        }

        const env = {
            platform: ePlatformCustom.CustomWeb,
            host: eHostCustom.CustomHost,
            office: OFFICE_API_WEB_VERSION,
        }

        return new CoreEnv(env)
    }
}
